import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const BellOffIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M19 11.5V14.2152L17 12.2152V11.5C17 8.74 14.76 6.5 12 6.5C11.7726 6.5 11.5488 6.5152 11.3295 6.54464L9.68452 4.89969C9.94949 4.8072 10.2217 4.73027 10.5 4.67V3.5C10.5 2.67 11.17 2 12 2C12.83 2 13.5 2.67 13.5 3.5V4.67C16.64 5.35 19 8.15 19 11.5Z"
            fill="#222"
          />
          <path
            d="M17.5927 18.5H3V17.5L5 15.5V11.5C5 9.92634 5.52077 8.47405 6.39852 7.30586L3.13926 4.0466L4.58887 2.59698L21.9967 20.0048L20.5471 21.4544L17.5927 18.5ZM7.83161 8.73895L15.5927 16.5H7V11.5C7 10.4796 7.30618 9.53028 7.83161 8.73895Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M10.01 19.51C10.01 20.61 10.9 21.5 12 21.5C13.1 21.5 13.99 20.61 13.99 19.51H10.01Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
